const autoNgTemplateLoaderTemplate1 = require('./integratedApplicationsDatatable.html');

angular.module('shbdeployer.kubernetes').component('kubernetesIntegratedApplicationsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
  },
});
